import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Checkbox, Select } from 'antd';
import { theme } from 'utils/style/theme';
import iconSearch from 'utils/icon/icon_search-black.png';
import { IoIosClose } from 'react-icons/io';
const { Option } = Select;
/**
 * * 기본 셀렉 박스 (드롭다운)
 */

interface IOptionList {
  key?: string | number;
  value?: string | number;
  text?: string | number;
  name?: string | number;
  id?: string | number;
}
interface IProps {
  allowClear?: boolean;
  bottom?: string | boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  noMarginBottom?: boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  defaultValue?: string | string[] | number | number[];
  disabled?: boolean;
  filterOption?: boolean;
  id?: string;
  key?: string;
  mode?: 'multiple' | 'tags' | undefined;
  name?: string;
  optionList?: IOptionList[];
  onChange?: (e, d) => void;
  onSearch?: (e: any) => void;
  onInputKeyDown?: (e: any) => void;
  onKeyUp?: (e) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  showSearch?: boolean;
  title?: string;
  tokenSeparators?: Array<string>;
  value?: string | string[] | number | number[];
  width?: string | undefined;
  labelStyle?: React.CSSProperties;
  suffixIcon?: React.ReactNode;
  setValue: React.Dispatch<React.SetStateAction<string[]>>;
}
const SelectMultiple = ({
  title,
  optionList,
  placeholder,
  mode,
  value,
  defaultValue,
  name,
  onChange,
  onSearch,
  style,
  disabled,
  allowClear,
  onKeyUp,
  onInputKeyDown,
  filterOption,
  showSearch,
  tokenSeparators,
  width,
  id,
  key,
  bottom,
  noMarginBottom,
  labelStyle,
  suffixIcon,
  setValue,
}: IProps) => {
  return (
    <Container
      style={style}
      title={title}
      bottom={bottom}
      noMarginBottom={noMarginBottom}
      setValue={setValue}
    >
      <label style={labelStyle}>{title}</label>

      <div className='prefix-icon-wrapper'>
        <img src={iconSearch} width={20} height={20} alt='icon-search' />
      </div>
      {value && (value as string[] | number[]).length ? (
        <div className='remove-icon-wrapper' onClick={() => setValue([])}>
          <IoIosClose size='24' color='#3a4147' />
        </div>
      ) : (
        <></>
      )}
      <StyledSelect
        mode={mode}
        value={value}
        defaultValue={defaultValue}
        showSearch={showSearch} //이게.. showSearch ? showSearch: true 로 하고싶은데, 안먹혀서..
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        onSearch={onSearch}
        onInputKeyDown={onInputKeyDown}
        allowClear={allowClear}
        onKeyUp={onKeyUp}
        filterOption={filterOption}
        tokenSeparators={tokenSeparators}
        width={width}
        name={name}
        id={id}
        key={key}
        suffixIcon={suffixIcon || null}
        dropdownStyle={{ padding: 16, boxShadow: '0px 1px 4px 0px #6792F480' }}
        dropdownRender={(menu) => {
          return (
            <DropDownWrapper>
              <p className='titleDropDown' style={{ paddingBottom: 8 }}>
                Character
              </p>
              {menu}
            </DropDownWrapper>
          );
        }}
        menuItemSelectedIcon={(menu) => {
          return <Checkbox checked={menu.isSelected} />;
        }}
        setValue={setValue}
      >
        {optionList?.map((v) => {
          return (
            <Option key={v.key} value={v.value} name={name} id={id}>
              {v.text}
            </Option>
          );
        })}
      </StyledSelect>
    </Container>
  );
};

export default SelectMultiple;

SelectMultiple.defaultProps = {
  showSearch: false,
};

const Container = styled.div<IProps>`
  position: relative;
  /* margin-top: '0.5rem'; */
  margin-bottom: ${(props) => (props.noMarginBottom ? '0' : '0')};
  .titleDropDown {
    color: red;
  }
  min-width: ${(props) => (props.width ? props.width : '300px')};
  max-width: 50%;
  label {
    display: ${(props) => (props.title ? 'block' : 'none')};
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.3rem;
    margin-bottom: 0.2rem;
  }
  .prefix-icon-wrapper {
    position: absolute;
    z-index: 1;
    width: 3rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .suffixIcon-icon-wrapper {
    position: absolute;
    z-index: 1;
    width: 3rem;
    height: 100%;
    display: flex;
    left: 100%;
    align-items: center;
    justify-content: center;
    transform: translateX(-100%);
  }
  .remove-icon-wrapper {
    position: absolute;
    position: absolute;
    right: 0;
    top: 20%;
    transform: translate(-50%, 0);
    z-index: 1;
    cursor: pointer;
  }
`;
const StyledSelect = styled(Select)<IProps>`
  background-color: #fff;
  border-radius: 0.4rem;
  /* box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 5%); */
  width: 100%;
  .ant-select-selector {
    min-height: 38px;
    border: 1px solid ${theme.colors.gray_5};
    border-radius: 0.4rem;
    padding: 0 60px 0 33px;
  }
  /* 셀렉박스 안 텍스트 */
  .ant-select-single.ant-select-show-arrow,
  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-item {
    background-color: ${theme.colors.blue_50};
  }
  .ant-select-selection-placeholder {
    left: 40px;
    font-size: ${theme.fontSizes.normal};
    font-weight: 450;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: ${theme.colors.grayContent};
  }
  .ant-select-selection-search {
    margin-inline-start: 5px;
  }
`;

const DropDownWrapper = styled.div`
  .titleDropDown {
    font-size: ${theme.fontSizes.normal};
    font-weight: 450;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
  .ant-select-item {
    background-color: transparent !important;
    padding-left: 25px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    min-height: 24px;
    font-size: ${theme.fontSizes.normal};
    font-weight: 450;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
  .ant-select-item-option-state {
    position: absolute;
    top: 0;
    left: 0;
  }
`;
